function guidGenerator() {
	var S4 = function () {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	};
	return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

// Carousels
var ids = [];
for (const slider of document.querySelectorAll(".carousel.columns-3")) {
	const id = 'carousel-' + guidGenerator();
	slider.classList.add(id);
	slider.setAttribute('id', id);
	ids.push(id);
}
for (const slider of ids) {
	let count = document.getElementById(slider).children[0].childElementCount;
	let slidesScrolling = 3;
	if (count > 3 && count < 6) {
		slidesScrolling = count % 3;
	}
	var carousel = new FlexCarousel('.' + slider, {
		slidesPerPage: 3,
		slidesScrolling: slidesScrolling,
		infinite: false,
		circles: false,
		arrows: true,
		arrowsOverlay: false,
		nextButton: '<div class="icon_button round large"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M8.342 4.753a1 1 0 1 1 1.317-1.506l8 8a1 1 0 0 1 0 1.506l-8 8a1 1 0 1 1-1.317-1.506L15.482 12l-7.14-7.247Z"/></svg></div>',
		prevButton: '<div class="icon_button round large"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M15.659 4.753a1 1 0 0 0-1.318-1.506l-8 8a1 1 0 0 0 0 1.506l8 8a1 1 0 1 0 1.318-1.506L8.518 12l7.14-7.247Z"/></svg></div>'
	});
}

var col4_ids = [];
for (const slider of document.querySelectorAll(".carousel.columns-4")) {
	const id = 'carousel-' + guidGenerator();
	slider.classList.add(id);
	slider.setAttribute('id', id);
	col4_ids.push(id);
}
for (const slider of col4_ids) {
	let count = document.getElementById(slider).children[0].childElementCount;
	let slidesScrolling = 4;
	if (count > 4 && count < 8) {
		slidesScrolling = count % 4;
	}
	var carousel = new FlexCarousel('.' + slider, {
		slidesPerPage: 4,
		slidesScrolling: slidesScrolling,
		infinite: false,
		circles: false,
		arrows: true,
		arrowsOverlay: false,
		nextButton: '<div class="icon_button round large"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M8.342 4.753a1 1 0 1 1 1.317-1.506l8 8a1 1 0 0 1 0 1.506l-8 8a1 1 0 1 1-1.317-1.506L15.482 12l-7.14-7.247Z"/></svg></div>',
		prevButton: '<div class="icon_button round large"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M15.659 4.753a1 1 0 0 0-1.318-1.506l-8 8a1 1 0 0 0 0 1.506l8 8a1 1 0 1 0 1.318-1.506L8.518 12l7.14-7.247Z"/></svg></div>'
	});
}

jQuery(document).ready(function ($) {
	$('.masthead__slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 2500,
	});

	$('.articles-slider').each(function (elem) {
		let slider = $(this).find('.articles-slider__track');
		let prev_arrow = $(this).find('.prev-arrow');
		let next_arrow = $(this).find('.next-arrow');
		var settings = {
			infinite: false,
			slide: '.featured_card',
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			prevArrow: $(prev_arrow),
			nextArrow: $(next_arrow),
			responsive: [
				{
					breakpoint: 639,
					settings: {
						slidesToShow: 1.5,
						slidesToScroll: 1,
					},
				}
			],
		}
		$(slider).slick(settings);
	});

	$('.photo_gallery').each(function (elem) {
		let slider = $(this).find('.photo_track');
		let prev_arrow = $(this).find('.prev-arrow');
		let next_arrow = $(this).find('.next-arrow');
		var settings = {
			infinite: true,
			slide: '.image_holder',
			arrows: true,
			slidesToShow: 4,
			slidesToScroll: 4,
			prevArrow: $(prev_arrow),
			nextArrow: $(next_arrow),
			responsive: [
				{
					breakpoint: 639,
					settings: {
						slidesToShow: 1.5,
						slidesToScroll: 1,
						infinite: false,
					},
				}
			],
		}
		$(slider).slick(settings);
	});

	$('.category-posts').each(function(num, elem) {
		elem = $(elem);
		let arrows = $(elem).parents('.grid-container').children('.grid-x').find('.arrows');
		var settings = {
			infinite: false,
			slide: '.post-slide',
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			prevArrow: $(arrows).find('.prev-arrow'),
			nextArrow: $(arrows).find('.next-arrow'),
			centerMode: false,
			responsive: [
				{
					breakpoint: 640,
					settings: "unslick"
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				}
			]
		}
		elem.slick(settings);
		$(window).on('resize', function() {
			/* If we are below mobile breakpoint unslick the slider */
			if ($(window).width() < 640)
			{
				/* Do nothing (responsive Slick's setting will unslick the slider) */
				return;
			}
			/* We are above mobile breakpoint, initialize the slider if it is not already initialized */
			if (!elem.hasClass('slick-initialized'))
			{
				return elem.slick(settings);
			}
		});
	});

	function customScrollbars() {
		$('.slider_wrapper').each(function (i, obj) {
			var $this = $(this);
			var holder = $this.find('.slider_holder');
			var track = $this.find('.slider_track');
			var container_offset = $this.find('.grid-container').offset();
			track.css({ 'padding-left': container_offset.left + 15, 'padding-right': container_offset.left + 15 });
			// Scrollbar functionality
			var scrollbarWidth = $this.find('.slider_scroll_bar').width();
			var handleWidth = $this.find('.handle').width();
			var remaining = scrollbarWidth - handleWidth;
			var hsWidth = track[0].scrollWidth - track[0].clientWidth;
			var percent;
			var scrollPercent;
			var leftScroll = $this.find('.scroller.left');
			var rightScroll = $this.find('.scroller.right');
			leftScroll.on('click', function () {
				track.animate({ scrollLeft: "0px" }, 600);
			});
			rightScroll.on('click', function () {
				track.animate({ scrollLeft: hsWidth }, 600);
			});
			$this.find('.handle').draggable({
				axis: 'x',
				containment: 'parent',
				drag: function (event, ui) {
					percent = (ui.position.left / remaining);
					track.scrollLeft(percent * hsWidth);
				}
			});
			track.on('scroll', function () {
				scrollPercent = ($(this).scrollLeft() / (track[0].scrollWidth - track[0].clientWidth));
				$this.find('.handle').css({ left: (scrollPercent * remaining) });
			});
		});
	}
	// customScrollbars();

	var element = $(window);
	var current_size = element.width() + 'x' + element.height();
	var current_width = element.width();
	var shrinking = false;
	var growing = false;
	var resizeTimer;
	element.resize(function () {
		// customScrollbars();

		var this_size = $(this).width() + 'x' + $(this).height();
		if (current_width > $(this).width()) {
			shrinking = true;
			growing = false;
			if ($(this).width() <= 1024) {
			}
		}
		if (current_width < $(this).width()) {
			growing = true;
			shrinking = false;
			if ($(this).width() >= 1024) {
			}
		}
		if (current_size !== this_size) {
			current_size = this_size;
			current_width = $(this).width();
		}
	});
	if (current_width < 1024) {
	}

	// Alert Banner
	$('.alert_banner').each(function (num, elem) {
		let $elem = $(elem);
		let $alertID = $(this).data('alert');
		if (JSON.parse(window.localStorage.getItem(`${$alertID}`)) === null) {
			setTimeout(function () {
				$elem.slideDown();
			}, 500);
		} else if (typeof (JSON.parse(window.localStorage.getItem(`${$alertID}`))) === 'boolean') {
			if (!JSON.parse(window.localStorage.getItem(`${$alertID}`))) {
				$elem.slideUp();
			}
		}
		let $alertClose = $(this).find('.alertClose');
		$alertClose.click(function () {
			$elem.slideUp();
			window.localStorage.setItem(`${$alertID}`, 'true');
		});
	});


	// Filters functionality
	var $filtered = false;
	var $activeFilters = 0;
	$('.filtersHolder').each(function (i, obj) {
		$('.filtersHolder .filter_toggle').each(function (i, obj) {
			var $this = $(this);
			$this.on('click', function () {
				let $id = `#${$this.data('toggle')}`; // Getting id of section to be filtered
				$($this).toggleClass('active'); // Toggle 'active' class on filter button
				$activeFilters = $('.filter_toggle.active').length; // Count active filters
				// If filtered previously and no remaining toggles have 'active' class, show all sections
				if ($filtered && $activeFilters === 0) {
					$('.faqWrapper').slideDown().removeClass('inactive');
					$filtered = false;
				}
				// If filtered, toggle selected section
				else if ($filtered) {
					$($id).slideToggle().toggleClass('inactive');
					// If not filtered at all, set filtered to true and close all sections other than selected section
				} else {
					$('.faqWrapper:not(' + $id + ')').slideUp().addClass('inactive');
					$filtered = true;
				}
			});
		});
	});
	$('#clear_filters').on('click', function () {
		$('.faqWrapper').slideDown().removeClass('inactive');
		$('.filtersHolder .filter_toggle').removeClass('active');
		$filtered = false;
		$activeFilters = 0;
	});

	// Off canvas triggers 
	$('.off-canvas').on('opened.zf.offcanvas', function (event) {
		$('#nav-header').addClass('stuck');
		$('.off-canvas-content').addClass('stuck');
	});
	$('.off-canvas').on('closed.zf.offcanvas', function (event) {
		var closed = true;
		$('.off-canvas').each(function () {
			if ($(this).hasClass('is-open')) {
				closed = false;
			}
		});
		if (closed) {
			setTimeout(function () {
				$('#nav-header').removeClass('stuck');
				$('.off-canvas-content').removeClass('stuck');
			}, 500);
		}
	});
});